import { useRouteParams as useRouteParamsBase } from '../../../_hooks/useRouteParams';

interface RouteParams {
  clientId: string;
}

export const useRouteParams = () => {
  return useRouteParamsBase<RouteParams>();
};
